import AntiforgeryService from '../../../services/anti-forgery.service';
import LogService from '../../../services/log-service/log.service';

export type CookieConsentEndpoint = 'all' | 'necessary' | 'custom';

export async function callApiEndpoint(endpoint: CookieConsentEndpoint, success: boolean) {
  try {
    await fetch(`/api/cookieselector/${endpoint}${!success ? '?success=false' : ''}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': await AntiforgeryService.getToken(),
      },
    });
  } catch (error) {
    LogService.logError(error, 'Error calling cookie selector API endpoint');
  }
}
